import localVariants from "./local-image-variants.json";
import { optimizedImageVariants } from "./optimized-image-variants";

export interface DeliveryVariant {
  url: string;
  width: number;
  height: number;
}

/** Reject malformed stored metadata without losing the original image. */
export function imageVariants(value: unknown): DeliveryVariant[] {
  if (!Array.isArray(value)) return [];
  return value.flatMap((item: unknown) => {
    if (typeof item !== "object" || item === null) return [];
    const row = item as Record<string, unknown>;
    if (typeof row["url"] !== "string" || typeof row["width"] !== "number" || typeof row["height"] !== "number" || row["width"] <= 0 || row["height"] <= 0) return [];
    return [{ url: row["url"], width: row["width"], height: row["height"] }];
  }).sort((a, b) => a.width - b.width);
}

export function imageSrcSet(value: unknown): string | undefined {
  const variants = imageVariants(value);
  return variants.length > 1 ? variants.map((v) => `${v.url} ${v.width}w`).join(", ") : undefined;
}

/** Only known bundled URLs use generated files; external images keep their own metadata. */
export function deliveryVariants(src: string, stored?: unknown): DeliveryVariant[] {
  const variants = imageVariants(stored);
  if (variants.length > 1) return variants;
  const known: Record<string, DeliveryVariant[]> = localVariants;
  return optimizedImageVariants[src] ?? known[src] ?? variants;
}